import React from 'react';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import classes from './EditTwoFactorModal.module.css';

export const TwoFactorLoadErrorModal = ({ isOpen, onClose }: { isOpen: boolean; onClose: () => void }) => (
        <Modal isOpen={isOpen} className={classes.modal} contentClassName={classes.modalContent}>
            <ModalHeader className={classes.modalHeader}>
                User OTP Login Options
            </ModalHeader>

            <ModalBody>
                <p className="mb-4">
                    By default, the user should use SMS to receive their OTP. In some cases they will need to use the authenticator app.
                </p>
                <div className={classes.errorMessage}>
                    Unable to load settings. Please reach out to dev support for assistance.
                </div>
            </ModalBody>
            <ModalFooter className={classes.modalFooter}>
                <Button
                    color="primary"
                    size="sm"
                    onClick={onClose}
                >
                    Close
                </Button>
            </ModalFooter>
        </Modal>
    );